import { render, staticRenderFns } from "./ModelForm.vue?vue&type=template&id=0a50c15c&scoped=true"
import script from "./ModelForm.vue?vue&type=script&lang=js"
export * from "./ModelForm.vue?vue&type=script&lang=js"
import style0 from "./ModelForm.vue?vue&type=style&index=0&id=0a50c15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a50c15c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VForm,VProgressCircular,VRadio,VRadioGroup})
